module.exports = __webpack_public_path__ + "files/b45481f508ec8b25036b2491d3c89305.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/code.png
 ** module id = 377
 ** module chunks = 0
 **/